import { createAction } from "redux-actions";
import { FIND_PARAMETERS, UPDATE_PARAMETERS } from "../constants";
import { feathersFindDataAll } from "../services";

export const getParams = createAction(FIND_PARAMETERS, () => feathersFindDataAll('parameters',{} )());
export const updateParams = createAction(UPDATE_PARAMETERS, (object) => (object));